var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-close",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uF00D",
    transform: "translate(0.500000, 0.500000)",
    fill: "#212529",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.08878505,7.5 L14.8831776,13.2943925 C15.0389408,13.4501558 15.0389408,13.6214953 14.8831776,13.8084112 L13.8084112,14.8831776 C13.6214953,15.0389408 13.4501558,15.0389408 13.2943925,14.8831776 L12.3130841,13.8551402 L7.5,9.08878505 L1.70560748,14.8831776 C1.54984424,15.0389408 1.37850467,15.0389408 1.19158879,14.8831776 L0.11682243,13.8084112 C-0.03894081,13.6214953 -0.03894081,13.4501558 0.11682243,13.2943925 L5.91121495,7.5 L0.11682243,1.70560748 C-0.03894081,1.54984424 -0.03894081,1.37850467 0.11682243,1.19158879 L1.19158879,0.11682243 C1.37850467,-0.03894081 1.54984424,-0.03894081 1.70560748,0.11682243 L7.5,5.91121495 L13.2943925,0.11682243 C13.4501558,-0.03894081 13.6214953,-0.03894081 13.8084112,0.11682243 L14.8831776,1.19158879 C15.0389408,1.37850467 15.0389408,1.54984424 14.8831776,1.70560748 L13.8551402,2.68691589 L9.08878505,7.5 Z",
    id: "Path"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.b11a1dc8.svg";
export { ForwardRef as ReactComponent };